import React, { useState } from 'react';
import forgotLogo from '../assets/img/forgot.png';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import "../css/ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');

  function onChange(e) {
    setEmail(e.target.value);
  }

  async function onSubmit(e) {
    e.preventDefault();
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      toast.success('Email Sent');
    } catch (error) {
      toast.error('Could not send reset password');
    }
  }

  return (
    <section>

      <div className="forgot-container" style={{backgroundColor:"#121212",marginTop:"0"}}>
        <div className="image-wrapper"  style={{marginTop:"80px"}}>
          <img src={forgotLogo} alt="Forgot Password" className="forgot-image" />
        </div>
        <div className="form-wrapper">
        <h1 style={{color:"orange",fontWeight:"900",textAlign:"center",marginBottom:"40px"}}>Forgot Password</h1>
          <form onSubmit={onSubmit}>
            <input
              type="email"
              id="email"
              value={email}
              onChange={onChange}
              placeholder="Email Address"
              className="input-field"
            />
            <div className="options">
              <p>
                <Link to="/login" className="link">
                  Sign in instead
                </Link>
              </p>
            </div>
            <button type="submit" className="submit-button" style={{paddingBottom:"15px",paddingTop:"15px"}}>
              Send Reset Password
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
